export const data = [
  {
    item: 'Good Governance',
    type: 'targetedLevelOfPerformance',
    value: 0,
  },
  {
    item: 'Good Governance',
    type: 'baselineESGPerformance',
    value: 0,
  },
  {
    item: 'Good Governance',
    type: 'currentPerformance',
    value: 0,
  },
  {
    item: 'Safe Working Conditions',
    type: 'targetedLevelOfPerformance',
    value: 0,
  },
  {
    item: 'Safe Working Conditions',
    type: 'baselineESGPerformance',
    value: 0,
  },
  {
    item: 'Safe Working Conditions',
    type: 'currentPerformance',
    value: 0,
  },
  {
    item: 'Environmental Protection',
    type: 'targetedLevelOfPerformance',
    value: 0,
  },
  {
    item: 'Environmental Protection',
    type: 'baselineESGPerformance',
    value: 0,
  },
  {
    item: 'Environmental Protection',
    type: 'currentPerformance',
    value: 0,
  },
  {
    item: 'Economic Development',
    type: 'targetedLevelOfPerformance',
    value: 0,
  },
  {
    item: 'Economic Development',
    type: 'baselineESGPerformance',
    value: 0,
  },
  {
    item: 'Economic Development',
    type: 'currentPerformance',
    value: 0,
  },
];

